import { useEffect, useState ,useRef } from "react";
import styled from "styled-components";
import axios from "axios";
import Loader from "../components/Loader";
import AddInventoryCategoryModal from "../components/AddInventoryCategoryModal";
import FilterBar from "../components/filterBar";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Page = styled.div`
  min-height: 100vh;
  background: #f6f8fb;
  font-family: 'Segoe UI', 'Inter', Arial, sans-serif;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 24px 18px 32px;
`;

const PageTitle = styled.h2`
  font-size: 1.6rem;
  font-weight: 700;
  color: #21325b;
  margin-bottom: 18px;
  flex: 6;
`;

const TableCard = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(35,62,88,0.06);
  padding: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  th, td {
    text-align: left;
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
  }
  th {
    font-weight: 600;
    color: #2b3b5f;
  }
`;

const Button = styled.button`
  background: #3772FF;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.5rem 2rem;
  min-width: 80px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(35,62,88,0.05);
  &:hover {
    background: #245bb9;
  }
  margin: 10px 0;
`;

const Row = styled.div`
  display: flex;
  gap: 22px;
  margin-bottom: 0.3rem;
`;

export default function InventoryCategoryPage() {
  const userData = {
    user: JSON.parse(localStorage.getItem('user')),
    token: localStorage.getItem('access_token'),
  };
const fileInputRef = useRef(null);

  const isAdmin = userData.user.roles.role_name === "SUPER_ADMIN";
  const [isLoading, setIsLoading] = useState(false);
    const [allCategories, setAllCategories] = useState([]);

  const [categories, setCategories] = useState([]);
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editCategory, setEditCategory] = useState(null);

  const headers = { Authorization: `Bearer ${userData.token}` };
const [filterText, setFilterText] = useState("");
const [filterFromDate, setFilterFromDate] = useState(null);
const [filterToDate, setFilterToDate] = useState(null);
const [sortField, setSortField] = useState(null);
const [sortOrder, setSortOrder] = useState(null);
const [excelFile, setExcelFile] = useState(null);

  const navigate = useNavigate()
const hostname = window.location.hostname;
  const isInventoryDomain = hostname === 'inventory.fescafe.in' || hostname === 'localhost';
  const isRecordsDomain = hostname === 'records.fescafe.in' ;
useEffect(() => {
    if(!isAdmin)
      navigate(isRecordsDomain ?'/cashflow' : '/inventory/entries')
  }, []);
const downloadSampleExcel = () => {
  // Data extracted from your attached file
  const sampleData = [
    { category_name: "Dairy Products", category_description: "Milk and dairy-based items" },
    { category_name: "Beverages", category_description: "Drinks like tea, coffee, etc." },
    { category_name: "Snacks", category_description: "Quick bites and snacks" },
    { category_name: "Bakery", category_description: "Bread, cakes, and pastries" },
    { category_name: "Frozen Foods", category_description: "Frozen vegetables and meats" },
  ];

  // Create worksheet from JSON data
  const worksheet = XLSX.utils.json_to_sheet(sampleData);

  // Create a new workbook and append the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "CategoriesSample");

  // Write workbook and trigger download
  XLSX.writeFile(workbook, "Category_Upload_Excel_Sample.xlsx");
};

const handleFileChange = (e) => {
  setExcelFile(e.target.files[0]);
};
useEffect(()=>{
  if(excelFile)
  handleUploadExcel()
},[excelFile])
useEffect(() => {
  let filtered = allCategories;

  // Text filter on category_name
  if (filterText) {
    const lowerSearch = filterText.toLowerCase();
    filtered = filtered.filter(c =>
      c.category_name?.toLowerCase().includes(lowerSearch)
    );
  }

  // Date filter on created_at
  if (filterFromDate || filterToDate) {
    filtered = filtered.filter(c => {
      const createdAt = new Date(c.created_at);
      const from = filterFromDate ? new Date(filterFromDate) : null;
      const to = filterToDate ? new Date(filterToDate) : null;
      return (!from || createdAt >= from) && (!to || createdAt <= to);
    });
  }

  // Sorting
  if (sortField && sortOrder) {
    filtered = [...filtered].sort((a, b) => {
      let aVal = a[sortField];
      let bVal = b[sortField];

      if (sortField === "created_at" || sortField === "updated_at") {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      } else {
        aVal = aVal || "";
        bVal = bVal || "";
      }

      if (aVal < bVal) return sortOrder === "asc" ? -1 : 1;
      if (aVal > bVal) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  }

  setCategories(filtered);
}, [allCategories, filterText, filterFromDate, filterToDate, sortField, sortOrder]);

// Handlers
const handleTextFilter = (text) => setFilterText(text || "");
const handleDateFilter = (from, to) => {
  setFilterFromDate(from || null);
  setFilterToDate(to || null);
};
const handleSortChange = (field, order) => {
  setSortField(field);
  setSortOrder(order);
};
const handleResetFilters = () => {
  setFilterText("");
  setFilterFromDate(null);
  setFilterToDate(null);
  setSortField(null);
  setSortOrder(null);
};
// Excel export
const exportToExcel = () => {
  const data = categories.map(c => ({
    ID: c.id,
    CategoryName: c.category_name,
    Description: c.category_description || "-",
    CreatedBy: c.created_by ? `${c.created_by.first_name} ${c.created_by.last_name}` : "-",
    CreatedOn: new Date(c.created_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
    ModifiedBy: c.updated_by ? `${c.updated_by.first_name} ${c.updated_by.last_name}` : "-",
    ModifiedOn: new Date(c.updated_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
  }));
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Categories");
  XLSX.writeFile(workbook, "categories_export.xlsx");
};

// PDF export
const exportToPDF = () => {
  const doc = new jsPDF();
  const columns = [
    { header: "ID", dataKey: "id" },
    { header: "Category Name", dataKey: "category_name" },
    { header: "Description", dataKey: "category_description" },
    { header: "Created By", dataKey: "createdBy" },
    { header: "Created On", dataKey: "createdOn" },
    { header: "Modified By", dataKey: "modifiedBy" },
    { header: "Modified On", dataKey: "modifiedOn" },
  ];
  const rows = categories.map(c => ({
    id: c.id,
    category_name: c.category_name,
    category_description: c.category_description || "-",
    createdBy: c.created_by ? `${c.created_by.first_name} ${c.created_by.last_name}` : "-",
    createdOn: new Date(c.created_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
    modifiedBy: c.updated_by ? `${c.updated_by.first_name} ${c.updated_by.last_name}` : "-",
    modifiedOn: new Date(c.updated_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }),
  }));
  autoTable(doc, { columns, body: rows, margin: { top: 10 }, styles: { fontSize: 8 } });
  doc.save("categories_export.pdf");
};

  const fetchCategories = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${BACKEND_URL}/categories`, { headers });
      setCategories(res.data.sort((a, b) => a.id - b.id));
      setAllCategories(res.data.sort((a, b) => a.id - b.id))
    } catch (err) {
      console.error("Error fetching inventory categories:", err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);
const handleUploadExcel = async () => {
  if (!excelFile) {
    alert('Please select an Excel (.xls or .xlsx) file first.');
    return;
  }

  const allowedTypes = [
    'application/vnd.ms-excel', // .xls
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
  ];

  if (!allowedTypes.includes(excelFile.type)) {
    alert('Invalid file type. Please select an Excel (.xls or .xlsx) file.');
    return;
  }

  if(excelFile.size > 5 * 1024 * 1024) { // 5MB limit
    alert('File size exceeds 5MB limit. Please select a smaller file.');
    return;
  }

  setIsLoading(true);
  try {
    const formData = new FormData();
    formData.append('file', excelFile);

    const response = await axios.post(`${BACKEND_URL}/categories/import-excel`, formData, {
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data',
      },
    });

    if(response.status === 201 || response.status === 200) {
      alert(`Categories imported successfully! Inserted: ${response.data.inserted || 0}`);
    } else {
      alert('Upload completed with unexpected response.');
    }

    setExcelFile(null);
    fetchCategories();
  } catch (error) {
    console.error('Error uploading Excel:', error);
    if(error.response?.data?.error) {
      alert(`Import failed: ${error.response.data.error}`);
    } else {
      alert('Import failed due to a network or server error.');
    }
  } finally {
    setIsLoading(false);
  }
};

  const openAddModal = () => {
    setIsEditMode(false);
    setEditCategory(null);
    setIsAddCategoryModalOpen(true);
  };

  const openEditModal = (category) => {
    setIsEditMode(true);
    setEditCategory(category);
    setIsAddCategoryModalOpen(true);
  };
  const handleDeleteCategory = async (categoryId) => {
  if (!window.confirm("Are you sure you want to delete this category?")) return;

  setIsLoading(true);
  try {
    await axios.get(`${BACKEND_URL}/categories/delete/${categoryId}`, { headers });
    await fetchCategories();
  } catch (err) {
    console.error("Error deleting category:", err.message);
  } finally {
    setIsLoading(false);
  }
};


  return (
    <>
      {isLoading && <Loader />}
      <Page>
        <Container>
          <Row>
            <PageTitle>Inventory Categories</PageTitle>
            {isAdmin && <Button onClick={openAddModal}>Add Category</Button>}
            <input
  type="file"
  accept=".xls,.xlsx"
  ref={fileInputRef}
  style={{ display: "none" }}
  onChange={handleFileChange}
/>
<Button onClick={() => fileInputRef.current && fileInputRef.current.click()} disabled={isLoading}>
  Upload Excel
</Button>
<Button onClick={() => downloadSampleExcel()} disabled={isLoading}>
  Import format(Excel)
</Button>
          </Row>
           <Row>
            
                      <FilterBar
  placeholder="Search Categories..."
  sortFields={[
    { value: "category_name", label: "Category Name" },
    { value: "created_at", label: "Created Date" },
  ]}
  onTextFilter={handleTextFilter}
  onDateFilter={handleDateFilter}
  onSortChange={handleSortChange}
  onResetFilters={handleResetFilters}
  onExportPDF={exportToPDF}
  onExportExcel={exportToExcel}
/>

                    </Row>
          <TableCard>
            <Table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Category Name</th>
                  <th>Description</th>
                  <th>Created by</th>
                  <th>Created on</th>
                  <th>Last modified by</th>
                  <th>Last modified on</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((c) => (
                  <tr key={c.id}>
                    <td>{c.id}</td>
                    <td>{c.category_name}</td>
                    <td>{c.category_description || '-'}</td>
                    <td>{c.created_by ? `${c.created_by.first_name} ${c.created_by.last_name}` : '-'}</td>
                    <td>{c.created_at ? new Date(c.created_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }) : '-'}</td>
                    <td>{c.updated_by ? `${c.updated_by.first_name} ${c.updated_by.last_name}` : '-'}</td>
                    <td>{c.updated_at ? new Date(c.updated_at).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' }) : '-'}</td>
                    <td>
                      <Button onClick={() => openEditModal(c)} disabled={!isAdmin}>
                        Edit
                      </Button>
                    </td>
                    <td>
  <Button
    onClick={() => handleDeleteCategory(c.id)}
    disabled={!isAdmin}
    style={{ marginLeft: '8px', backgroundColor: '#d9534f' }}
  >
    Delete
  </Button>
</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableCard>

          {isAddCategoryModalOpen && (
            <AddInventoryCategoryModal
              isOpen={isAddCategoryModalOpen}
              isEdit={isEditMode}
              editCategory={editCategory}
              onClose={() => {
                setIsAddCategoryModalOpen(false);
                setEditCategory(null);
                setIsEditMode(false);
              }}
              onCategoryAdded={fetchCategories}
              onCategoryUpdated={fetchCategories}
            />
          )}
        </Container>
      </Page>
    </>
  );
}
